import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../components/global/modal/withModal';
import { getAsset } from '../../../../../util/assets';
import Button from '../../../../../components/global/Button';

const propTypes = {
  name: PropTypes.string.isRequired,
  onReset: PropTypes.func.isRequired,
  onComplete: PropTypes.func.isRequired,
};

const CustomPrintCheckoutSuccess = ({ name, onReset, onComplete }) => {
  return (
    <div className="text-center">
      <img
        src={getAsset('/waldo-excited.png')}
        alt=""
        width="58"
        className="mb-2"
      />

      <p className="m-0 text-md text-dark text-extra-bold">Wowzers!</p>
      <p className="text-dark text-bold">
        That was a nice {name.toLowerCase()}!
      </p>

      <p className="m-0">
        Your order is being processed and you&rsquo;ll receive it soon!
      </p>

      <Button btnBlock btnSize="lg" onClick={onReset} className="mt-5">
        Create another one
      </Button>

      <Button btnStyle="link" onClick={onComplete} className="mt-3">
        I&rsquo;m all done, thanks!
      </Button>
    </div>
  );
};

CustomPrintCheckoutSuccess.propTypes = propTypes;

export { CustomPrintCheckoutSuccess };

export default withModal(CustomPrintCheckoutSuccess, {
  dismissible: false,
  hideHeader: true,
  size: 'sm',
});
